import { useIsTransferState } from 'pages/Transfer/Transfer.context'
import {
  TransferBpayState,
  TransferContactState,
  TransferGeneralState,
  TransferZellerState,
} from 'pages/Transfer/Transfer.stateMachine'

const SummaryZellerStates = [
  TransferZellerState.Sending,
  TransferZellerState.Summary,
  TransferZellerState.Complete,
]

const SummaryContactTransferStates = [
  TransferContactState.Summary,
  TransferContactState.Sending,
  TransferContactState.DeOutFallbackSummary,
  TransferContactState.DeOutFallbackSending,
  TransferContactState.Complete,
]

const SummaryBpayTransferStates = [
  TransferBpayState.Summary,
  TransferBpayState.Sending,
  TransferBpayState.Complete,
]

export const useIsTransferSummaryState = () => {
  const isZellerState = useIsTransferState(TransferGeneralState.ZellerTransfer)
  const isContactTransferState = useIsTransferState<TransferContactState>(
    TransferGeneralState.ContactTransfer
  )
  const isBpayTransferState = useIsTransferState<TransferBpayState>(
    TransferGeneralState.BpayTransfer
  )

  return (
    isZellerState(SummaryZellerStates) ||
    isContactTransferState(SummaryContactTransferStates) ||
    isBpayTransferState(SummaryBpayTransferStates)
  )
}
